import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-291ff257"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  class: "boxed-container",
  "data-cy": "account-container"
}
const _hoisted_3 = { class: "m-4" }
const _hoisted_4 = { class: "mb-6" }
const _hoisted_5 = {
  class: "label",
  "data-cy": "label-name"
}
const _hoisted_6 = { "data-cy": "userName" }
const _hoisted_7 = {
  class: "label",
  "data-cy": "label-email"
}
const _hoisted_8 = { "data-cy": "userEmail" }
const _hoisted_9 = {
  class: "label",
  "data-cy": "label-profileImage"
}
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = {
  class: "label",
  "data-cy": "label-selectLanguage"
}
const _hoisted_12 = { class: "label" }
const _hoisted_13 = {
  class: "container",
  "data-cy": "password-container"
}
const _hoisted_14 = { class: "boxed-container" }
const _hoisted_15 = { class: "m-4" }
const _hoisted_16 = { class: "m-4 mb-0" }
const _hoisted_17 = { class: "container" }
const _hoisted_18 = { class: "boxed-container" }
const _hoisted_19 = { class: "m-4" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "m-4" }, " App Info ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " App Version ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Backend Version ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Backend Url ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Production Mode ", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Logs ", -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Show Debugging Logs ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserDialogButton = _resolveComponent("UserDialogButton")!
  const _component_toolbar = _resolveComponent("toolbar")!
  const _component_IonImg = _resolveComponent("IonImg")!
  const _component_AFlatButton = _resolveComponent("AFlatButton")!
  const _component_SelectLanguage = _resolveComponent("SelectLanguage")!
  const _component_AInput = _resolveComponent("AInput")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_toolbar, {
        title: "Einstellungen",
        "show-back-button": "",
        onOnBackButtonClicked: _cache[0] || (_cache[0] = () => {})
      }, {
        trailing: _withCtx(() => [
          _createVNode(_component_UserDialogButton)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("einstellungen.account")), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.rowClass)
                }, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("einstellungen.name")), 1),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.user.username), 1)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.rowClass)
                }, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("einstellungen.email")), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.user.email), 1)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.rowClass)
                }, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("einstellungen.profilbild")), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_IonImg, {
                      "data-cy": "profileImage",
                      src: 
                    _ctx.user.profilbild
                      ? _ctx.getPhotoUrl(_ctx.user.profilbild)
                      : './assets/img/profiles/placeholder_profile_image.png'
                  ,
                      class: "rounded-full overflow-hidden mr-4",
                      style: {"width":"64px","height":"64px","background":"white"}
                    }, null, 8, ["src"]),
                    _createVNode(_component_AFlatButton, {
                      "data-cy": "button-uploadProfileImage",
                      onClick: _ctx.uploadProfileImage
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("buttons.aendern")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ], 2),
                (_ctx.isDev)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(_ctx.rowClass)
                    }, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("einstellungen.sprache")), 1),
                      _createVNode(_component_SelectLanguage)
                    ], 2))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.rowClass)
                }, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("einstellungen.logout")), 1),
                  _createVNode(_component_AFlatButton, {
                    "data-cy": "button-logout",
                    onClick: _ctx.logout
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('buttons.logout')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 2)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h1", _hoisted_16, _toDisplayString(_ctx.$t("einstellungen.passwortAendern")), 1),
                _createElementVNode("form", {
                  novalidate: "",
                  onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onChangePassword && _ctx.onChangePassword(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_AInput, {
                      modelValue: _ctx.changePasswordForm.currentPassword.$model,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.changePasswordForm.currentPassword.$model) = $event)),
                      "data-cy": "input-currentPassword",
                      class: "px-4 max-w-sm",
                      "input-type": "password",
                      label: _ctx.t('einstellungen.aktuellesPasswort'),
                      errors: _ctx.changePasswordForm.currentPassword.$errors
                    }, null, 8, ["modelValue", "label", "errors"]),
                    _createVNode(_component_AInput, {
                      modelValue: _ctx.changePasswordForm.newPassword.$model,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.changePasswordForm.newPassword.$model) = $event)),
                      "data-cy": "input-newPassword",
                      class: "px-4 max-w-sm",
                      "input-type": "password",
                      label: _ctx.t('einstellungen.neuesPasswort'),
                      errors: _ctx.changePasswordForm.newPassword.$errors
                    }, null, 8, ["modelValue", "label", "errors"]),
                    _createVNode(_component_AInput, {
                      modelValue: _ctx.changePasswordForm.confirmNewPassword.$model,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.changePasswordForm.confirmNewPassword.$model) = $event)),
                      "data-cy": "input-confirmNewPassword",
                      class: "px-4 max-w-sm",
                      "input-type": "password",
                      label: _ctx.t('einstellungen.neuesPasswortBestätigen'),
                      errors: _ctx.changePasswordForm.confirmNewPassword.$errors
                    }, null, 8, ["modelValue", "label", "errors"]),
                    _createVNode(_component_AFlatButton, {
                      type: 'submit',
                      "data-cy": "button-updatePassword",
                      class: "mt-4 mb-4"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("einstellungen.passwortAendern")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ], 32)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", null, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClass)
                  }, [
                    _hoisted_21,
                    _createElementVNode("div", null, _toDisplayString(_ctx.getVar("VUE_APP_BUILD_VERSION")), 1)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClass)
                  }, [
                    _hoisted_22,
                    _createElementVNode("div", null, _toDisplayString(_ctx.backendBuildVersion), 1)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClass)
                  }, [
                    _hoisted_23,
                    _createElementVNode("div", null, _toDisplayString(_ctx.getVar("VUE_APP_BACKEND_URL")), 1)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClass)
                  }, [
                    _hoisted_24,
                    _createElementVNode("div", null, _toDisplayString(["prod","production"].includes(_ctx.getVar("NODE_ENV").toLowerCase())), 1)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClass)
                  }, [
                    _hoisted_25,
                    _createElementVNode("div", null, [
                      _createVNode(_component_AFlatButton, {
                        class: "mt-2",
                        onClick: _cache[5] || (_cache[5] = () => _ctx.goToLogs())
                      }, {
                        default: _withCtx(() => [
                          _hoisted_26
                        ]),
                        _: 1
                      })
                    ])
                  ], 2)
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}